import React, {  useState } from 'react';
import { Service } from '../../../types';
import { addService, fetchServices, updateService } from '../../../features/admin/serviceSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';


type Props = {
    initialData: Service | null;
    onClose: () => void;
    onSuccess: () => void;
};

const ServiceModal = ({ initialData, onClose, onSuccess }: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>()

    const [formData, setFormData] = useState<{
        id?: number;
        title: string;
        titleAr:string;
        image: string | File;
    }>({
        id: initialData?.id,
        title: initialData?.title || '',
        titleAr: initialData?.titleAr || '',
        image: initialData?.image || ''
    });
    const [imagePreview, setImagePreview] = useState<string>(
        typeof formData.image === 'string' ? formData.image : ''
    );

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setFormData({ ...formData, image: file });
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

const handleSubmit = async () => {
    if (formData.title.length < 3 || !formData.image) {
        toast.error(t("add-service-error"));
        return;
    }

    try {
        const data = new FormData();
        
        data.append("title", formData.title);
        data.append("titleAr", formData.titleAr);
        if (formData.image instanceof File) {
            data.append("image", formData.image);
        }

        if (initialData && initialData.id) {
            data.append("id", initialData.id.toString());
            await dispatch(updateService({
                data
            }));
        } else {
            await dispatch(addService(data));
        }
        await dispatch(fetchServices());
        onSuccess();
        onClose();
    } catch (error) {
        toast.error(t("error-message"));
    }
};



    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center p-5 z-50">
            <div className="bg-white p-6 rounded-xl w-full max-w-md shadow-lg space-y-4">
                <h2 className="text-xl font-bold text-center">
                    {initialData ? t("sercvice-title-edit") : t("sercvice-title-create")}
                </h2>

                <input
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    placeholder={t("service-title-placeholder")}
                    className="w-full border rounded px-3 py-2"
                />
                <input
                    name="titleAr"
                    value={formData.titleAr}
                    onChange={handleChange}
                    placeholder={t("service-title-placeholderAr")}
                    className="w-full border rounded px-3 py-2"
                />
                <div className="w-full">
                    <label htmlFor="image-upload" className="block cursor-pointer">
                        <div className="w-full h-40 border border-dashed rounded flex items-center justify-center bg-gray-50 hover:bg-gray-100 transition">
                            {imagePreview ? (
                                <img
                                    src={imagePreview}
                                    alt="Preview"
                                    className="w-full h-full object-cover rounded"
                                />
                            ) : (
                                <span className="text-gray-500">{t("click_to_select")}</span>
                            )}
                        </div>
                    </label>

                    <input
                        id="image-upload"
                        type="file"
                        name="image"
                        accept="image/*"
                        onChange={handleImageChange}
                        className="hidden"
                    />
                </div>
                <div className="flex justify-between pt-4">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">
                        {t("cancel")}
                    </button>
                    <button onClick={handleSubmit} className="px-4 py-2 bg-primary text-white rounded">
                        {initialData ? t("update") : t("create")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ServiceModal;
